import React from 'react'
import { Navigate } from 'react-router-dom'
import apiService from '@/api/service'

interface ProtectedRouteProps {
    children: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const isLoggedIn = apiService.isLoggedIn()

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />
    }

    return <>{children}</>
}

export default ProtectedRoute
